document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-featured-tarte-gallery]').forEach(function(gallery) {
    const sectionId = gallery.dataset.featuredTarteGallery;
    if (!gallery.closest('.featured-product-tarte__gallery')) return;

    const mainMedias = gallery.querySelectorAll('.featured-product-tarte__main-media');
    const thumbs = gallery.parentElement.querySelectorAll('.featured-product-tarte__thumb');
    const thumbList = gallery.parentElement.querySelector('[data-thumb-list]');
    const prevBtn = gallery.parentElement.querySelector('[data-thumb-prev]');
    const nextBtn = gallery.parentElement.querySelector('[data-thumb-next]');

    function showMedia(mediaId) {
      mainMedias.forEach(function(m) { m.classList.toggle('is-active', m.dataset.mediaId == mediaId); });
      thumbs.forEach(function(t) { t.classList.toggle('is-active', t.dataset.mediaId == mediaId); });
    }

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() { showMedia(thumb.dataset.mediaId); });
    });

    if (prevBtn && thumbList) {
      prevBtn.addEventListener('click', function() {
        const active = thumbList.querySelector('.is-active');
        const prev = active ? active.previousElementSibling : thumbList.lastElementChild;
        if (prev) showMedia(prev.dataset.mediaId);
      });
    }
    if (nextBtn && thumbList) {
      nextBtn.addEventListener('click', function() {
        const active = thumbList.querySelector('.is-active');
        const next = active ? active.nextElementSibling : thumbList.firstElementChild;
        if (next) showMedia(next.dataset.mediaId);
      });
    }
  });
});
